import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import { Input } from 'widget/components';
import { useWidgetContext } from 'widget/widget-context';

const Phone = () => {
  const { widget } = useWidgetContext();

  const [field, meta, helpers] = useField<string>('phone');
  const { t } = useTranslation();

  const isValid = !(meta.error && meta.touched);

  return (
    <Input
      {...field}
      isValid={isValid}
      onChange={helpers.setValue}
      placeholder={`${t`Phone number`}${widget.is_phone ? '*' : ''}`}
      style={{ marginBottom: 16 }}
      type="tel"
    />
  );
};

export default Phone;
